import { render } from "./AccountConfirmResetPassword.vue?vue&type=template&id=dcaec4a0&scoped=true"
import script from "./AccountConfirmResetPassword.vue?vue&type=script&lang=js"
export * from "./AccountConfirmResetPassword.vue?vue&type=script&lang=js"

import "./AccountConfirmResetPassword.vue?vue&type=style&index=0&id=dcaec4a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcaec4a0"]])

export default __exports__